import { Wrapper, StyledIconCamera } from "./styled";

export const MovieMissingPoster = () => (
    <Wrapper>
        <StyledIconCamera />
    </Wrapper>
);